import React from 'react';
import { Label } from '../Label';
export const ClubRAppLabel = ({ discount }) => (React.createElement(Label, { icon: "RakutenSymbol", backgroundColor: "red800", letterSpacing: "normal", borderRadius: "2px", padding: "1px 6px 4px 6px", iconSize: "12px", iconStyle: { position: 'relative', top: '1px' } },
    discount,
    "%"));
